export enum WorkflowStatusEnum {
  Open = 0,
  Closed = 1,
}
